import { render, staticRenderFns } from "./BalanceTransfer.vue?vue&type=template&id=82caef72&scoped=true"
import script from "./BalanceTransfer.vue?vue&type=script&lang=ts"
export * from "./BalanceTransfer.vue?vue&type=script&lang=ts"
import style0 from "./BalanceTransfer.vue?vue&type=style&index=0&id=82caef72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82caef72",
  null
  
)

export default component.exports